import { useEffect, useRef, useState } from "react";
import CountUpNumber from "@/components/CountUpNumber";
import { ParallaxImage, ParallaxText, ScrollFadeIn } from "@/components/Parallax";

const STATS = [
  { value: "25", suffix: "+", label: "años de experiencia" },
  { value: "100000", suffix: "+", label: "casos gestionados" },
  { value: "100", suffix: "%", label: "cobertura nacional" },
];

export default function IdentidadSection() {
  return (
    <section id="identidad" data-testid="identidad-section" className="py-20 md:py-28 lg:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image with parallax */}
          <ScrollFadeIn direction="left" delay={0}>
            <ParallaxImage
              src="/images/escritorio.png"
              alt="Escritorio con libros y globo terráqueo"
              className="grayscale-img"
              containerClassName="w-full h-[350px] lg:h-[500px] rounded-sm shadow-2xl"
              speed={0.5}
            />
          </ScrollFadeIn>

          {/* Content with text parallax */}
          <div className="relative z-10">
            <ParallaxText speed={-0.1}>
              <ScrollFadeIn direction="right" delay={0}>
                <p className="text-calle-primary-50 text-xs uppercase tracking-[0.3em] mb-4 font-semibold font-body">
                  Experiencia en cobranza judicial
                </p>
              </ScrollFadeIn>
              <ScrollFadeIn direction="right" delay={0.1}>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-calle-primary leading-[1.1] tracking-[-0.01em] mb-6">
                  Calle & Cía. Abogados
                </h2>
              </ScrollFadeIn>
              <ScrollFadeIn direction="right" delay={0.15}>
                <div className="calle-underline mb-8"></div>
              </ScrollFadeIn>
            </ParallaxText>
            
            <ParallaxText speed={-0.05}>
              <ScrollFadeIn direction="right" delay={0.2}>
                <p className="text-gray-600 text-base leading-relaxed mb-8 font-body">
                  En Calle & Cía. Abogados somos especialistas en el recupero judicial de créditos.
                  Nuestros principales clientes son bancos e instituciones financieras.
                  Nuestra experiencia se concentra en la cobranza judicial, la gestión de carteras de créditos impagos, con o sin garantías asociadas, siempre orientados a la eficiencia de los recursos en el recupero de las acreencias.
                </p>
              </ScrollFadeIn>
            
              <ScrollFadeIn direction="right" delay={0.25}>
                <div className="bg-gray-50 p-6 rounded-sm mb-8 border-l-4 border-calle-primary">
                  <p className="text-calle-primary/80 text-sm font-medium font-body mb-2">
                    Alta continuidad con clientes institucionales
                  </p>
                  <p className="text-gray-500 text-sm font-body">
                    Relaciones duraderas basadas en confianza, transparencia y resultados consistentes.
                  </p>
                </div>
              </ScrollFadeIn>

              <ScrollFadeIn direction="up" delay={0.3}>
                <div data-testid="identidad-stats" className="grid grid-cols-3 gap-4">
                  {STATS.map((stat, i) => (
                    <div key={stat.label} className={`${i > 0 ? "border-l border-gray-200 pl-4 lg:pl-6" : ""}`}>
                      <p className="font-heading text-2xl sm:text-3xl lg:text-4xl text-calle-primary mb-1 tracking-[-0.02em]">
                        <CountUpNumber target={stat.value} />{stat.suffix}
                      </p>
                      <p className="text-gray-500 text-xs sm:text-sm font-body">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </ScrollFadeIn>
            </ParallaxText>
          </div>
        </div>
      </div>
    </section>
  );
}
